import { createUseStyles } from "react-jss";
import { ITheme } from "../../types/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  checkbox: {
    appearance: "none",
    cursor: "pointer",
    width: 20,
    height: 20,
    border: `2px solid ${theme.colors.border2}`,
    background: theme.colors.background6,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing.space4,
    boxSizing: "border-box",
    "&:hover": {
      border: `2px solid ${theme.colors.primary}`,
    },
    "&.checkbox": {
      borderRadius: 2,
    },
    "&.disabled": {
      border: `2px solid ${theme.colors.border1}`,
      background: theme.colors.background5,
      "&.checked": {
        background: `linear-gradient(0deg, rgba(0, 0, 0, 0.50) 0%, rgba(0, 0, 0, 0.50) 100%), ${theme.colors.primary}`,
        borderColor: "transparent",
        "& > span": {
          color: theme.colors.background1,
        },
      },
    },
    "&.checked": {
      appearance: "checkbox",
      accentColor: theme.colors.primary,
      border: `2px solid ${theme.colors.primary}`,
      background: theme.colors.primary,
      display: "flex",
      alignItems: "center",
      "&.radio": {
        background: "transparent",
      },
    },
    "&.circle": {
      borderRadius: "50%",
    },
  },
  radioDot: {
    width: 8,
    height: 8,
    borderRadius: "50%",
    background: theme.colors.primary,
  },
}));
